
import { mapMutations } from 'vuex';
import Price from '~/components/helpers/Price';
export default {
    components: { Price },
    methods: {
        ...mapMutations('compare', ['removeProductFromCompareShop'])
    },
    props: ['product']
};
